import React, { useEffect, useState } from 'react'
import { Header } from './header'
import { Footer } from './footer'
import { AboutSEO } from './SEO'
import { listteammembers } from '../services/homeser'

// Shown only if the API returns no team members (e.g. before any are added).
const fallbackTeam = [
    { id: 'f1', name: 'Manivannan', designation: 'Founder', image: require('../assets/images/avatar/01.jpg') },
    { id: 'f2', name: 'Team Member', designation: 'Design Head', image: require('../assets/images/avatar/02.jpg') },
    { id: 'f3', name: 'Team Member', designation: 'Sales Manager', image: require('../assets/images/avatar/03.jpg') },
    { id: 'f4', name: 'Team Member', designation: 'Customer Support', image: require('../assets/images/avatar/04.jpg') },
]

export const About = () => {
    const [team, setTeam] = useState([])

    useEffect(() => {
        listteammembers()
            .then((res) => {
                if (res?.status && Array.isArray(res.data) && res.data.length > 0) {
                    setTeam(res.data)
                }
            })
            .catch(() => { /* keep fallback on failure */ })
    }, [])

    const teamMembers = team.length > 0 ? team : fallbackTeam

    return (
        <>
            <AboutSEO />
            <Header />
            <section className="inner-section single-banner" style={{ background: "url(" + require("../assets/images/slider/single-banner.jpg") + ") no-repeat center" }}>
                <div className="container">
                    <h2>About us</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a>Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">about</li>
                    </ol>
                </div>
            </section>

            <section className="inner-section about-company">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="about-content">
                                <h2>About ASM Wedding Cards</h2>
                                <p>Welcome to ASM Wedding Cards, where your wedding dreams take shape with beauty, elegance, and
                                    precision. With over 15 years of experience in the industry, we have earned a reputation for
                                    creating memorable wedding invitations and stationery that capture the essence of every
                                    special moment.

                                    At ASM Wedding Cards, we take pride in offering an extensive range of designs, with over
                                    2,000+ unique modules to choose from. Our collection blends traditional craftsmanship with
                                    modern trends, ensuring that every couple finds the perfect design to match their style and
                                    theme. Located in Valappady, we are proud to be the one and only wedding card showroom in
                                    the area, and one of the largest and finest showrooms in Salem.</p>
                            </div>
                            <ul className="about-list">
                                <li>
                                    <h3>15000 +</h3>
                                    <h6>Customers</h6>
                                </li>
                                <li>
                                    <h3>2000 +</h3>
                                    <h6>Card Designs</h6>
                                </li>
                                <li>
                                    <h3>100000 +</h3>
                                    <h6>INVITATIONS CARDS</h6>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-6">
                            <div className="blog-img">
                                <img src={require("../assets/images/slider/asm-about.jpg")} alt="about" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="inner-section offer-part">
                <div className="container">
                    <div className="row">
                        <div className="col-11 col-md-9 col-lg-7 col-xl-6 mx-auto">
                            <div className="section-heading">
                                <h2>Reputed Organization Members with ASM Manivannan</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <div className="offer-card">
                                <a href="#"><img src={require("../assets/images/slider/Tamilmani.jpg")} alt="Members" /></a>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <div className="offer-card">
                                <a href="#"><img src={require("../assets/images/slider/Ashny-Graphics-1.jpg")} alt="Members" /></a>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <div className="offer-card">
                                <a href="#"><img src={require("../assets/images/slider/Eswar-Jewellers.jpg")} alt="Members" /></a>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <div className="offer-card">
                                <a href="#"><img src={require("../assets/images/slider/Thiyagarajar-Polytechnic.jpg")} alt="Members" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="inner-section team-part">
                <div className="container">
                    <div className="row">
                        <div className="col-11 col-md-9 col-lg-7 col-xl-6 mx-auto">
                            <div className="section-heading">
                                <h2>Our Team Members</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        {teamMembers.map((member) => (
                            <div className="col-sm-6 col-md-4 col-lg-3" key={member.id}>
                                <div className="team-card">
                                    <div className="team-img">
                                        <img src={member.image} alt={member.name || "Team Member"} />
                                    </div>
                                    <div className="team-content">
                                        <h5>{member.name}</h5>
                                        <span>{member.designation}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            <Footer />
        </>
    )
}
